import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import submit from "submit-form";
import ToolTip from "../../../../parts/tooltip";
import SvgIcon from "../../../../parts/SvgIcon";

const TeamWeekSetting = ({ program, cycle, locals }) => {
  const { t } = useTranslation("coaching-portal");
  const week = cycle.programs.find((prog) => prog.order === program);

  const [weekSettings, setWeekSettings] = useState({
    name: week.name,
    description: week.description,
    video: week.video,
  });

  const handleChange = (target) => {
    setWeekSettings((prev) => ({
      ...prev,
      [target.name]: target.value,
    }));
  };

  const submitChange = () => {
    const cycleId = cycle._id;

    const body = {
      name: weekSettings.name,
      description: weekSettings.description,
      video: weekSettings.video,
    };

    submit(
      `/actions/cycle/edit/program/${cycleId}?program=${program}&athlete=`,
      {
        method: "POST",
        body,
      }
    );
  };

  return (
    <Modal
      className="week-settings-modal"
      title={t("teams.weekSettings.title")}
      toClear={["program", "cycleId"]}
    >
      <div className="body">
        <div className="group">
          <label htmlFor="name">{t("teams.weekSettings.weekName")}</label>
          <input
            name="name"
            className="text-input"
            defaultValue={weekSettings.name}
            placeholder={t("teams.weekSettings.weekNamePlaceholder")}
            onChange={({ target }) => {
              handleChange(target);
            }}
          />
        </div>

        <div className="group">
          <label htmlFor="description">{t("teams.weekSettings.weekDescription")}</label>
          <input
            name="description"
            className="text-input"
            defaultValue={weekSettings.description}
            placeholder={t("teams.weekSettings.weekDescriptionPlaceholder")}
            onChange={({ target }) => {
              handleChange(target);
            }}
          />
        </div>

        <div className="group">
          <div className="flex flex-row items-center gap-2 mb-2">
            <label htmlFor="video" className="mb-0!">
              {t("teams.weekSettings.weeklyVideoOptional")}
            </label>
            <ToolTip
              id={"week-video-tooltip"}
              body={t("teams.weekSettings.weeklyVideoTooltip")}
              childrenContainerClass="tooltip-coach"
              timeOut={1000}
              position="top"
            >
              <SvgIcon
                alt={t("teams.weekSettings.infoIconAlt")}
                src="/img/new-icons/question-circle.svg"
              />
            </ToolTip>
          </div>

          <input
            name="video"
            className="text-input"
            defaultValue={weekSettings.video}
            placeholder={t("teams.weekSettings.videoUrlPlaceholder")}
            onChange={({ target }) => {
              handleChange(target);
            }}
          />
        </div>
      </div>

      <footer>
        <div className="column" data-col="1/3">
          <a
            role="button"
            data-button-type="secondary"
            href="/actions/refresh?modal=&program="
          >
            {t("teams.weekSettings.cancel")}
          </a>
        </div>

        <div
          className="column mobile-hidden"
          data-col="1/3"
          style={{ textAlign: "right" }}
        >
          <button
            type="submit"
            data-button-type="primary"
            className="button-input"
            onClick={() => submitChange()}
          >
            {t("teams.weekSettings.save")}
          </button>
        </div>
      </footer>
    </Modal>
  );
};

export default TeamWeekSetting;
